import "../../sass/pages/sow.scss";
import { getTrees, sendTree, sendCdpData, getName, getMultiTree } from "../services/apis/siembra";
import Swal from "sweetalert2";
import { ITree } from "../types/siembra";
import CryptoJS from "crypto-js"
declare global {
    interface Window {
        drupalSettings: any
    }
}

const map = document.getElementById("map")
const scrollMap = document.querySelector(".eternos__map")
const name = document.getElementById("name")
const hand = document.getElementById("hand")
let pointsT: ITree[] = []

document.addEventListener("tapitLoad", (e: any) => {
    if (window.screen.width < 850) scrollMap.scrollLeft = 650
    onInit(e)
})

const onInit = async (e: any) => {
    try {
        const data = await getName()
        if (data) name.innerText = `Hola, ${data}`
    } catch (error) {
        console.error(error);
    }
    await getPoints()
    const points = [...document.getElementsByClassName("eternos__map__tree") as any] as HTMLElement[]
    const inputsContainer = [...document.getElementsByClassName("eternos__input") as any] as HTMLElement[]
    const broadcasts = [...document.getElementsByClassName("eternos__map__broadcast") as any] as HTMLElement[]
    const { newUser } = e.detail

    const sendPoint = async () => {

        try {

            if (pointsT.length > 0) {
                let point: ITree = null
                const format: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
                const freePoint = pointsT.find(item => (!item.date && !item.name && !item.lastname))
                if (!freePoint) {
                    point = pointsT.reduce((prv, crr) => {
                        if (new Date(crr.date) < new Date(prv.date)) {
                            prv = crr
                        }
                        return prv
                    })


                } else {
                    point = freePoint
                }
                const object = document.getElementById(`point(${point.x},${point.y})`)
                const data = await sendTree({
                    x: point.x,
                    y: point.y,
                });

                const indice = pointsT.findIndex(item => item === point)

                pointsT[indice] = data

                object.classList.add("me")
                object.innerHTML =
                    `
                <div class="eternos__tree__modal open">
                    <div class="eternos__modal__header">
                        <p>${data.name + " " + data.lastname}</p>
                        <button class="eternos__modal__close">X</button>
                    </div>
                    <div class="eternos__modal__body">
                        <img src="${map.getAttribute("data-treeFree")}"
                            alt="eternos__modal__image">
                        <p>Siembra digital: ${new Date(data.date).toLocaleDateString("ES-es", format)}</p>
                    </div>
                </div>
                <img class="eternos__tree__image"
                    src="${map.getAttribute("data-treeFill")}"
                    alt="tree(${data.x},${data.y})">
                `
                object.children[1].addEventListener("click", () => openDialog(object.children[0] as HTMLElement))
                const button = object.children[0].children[0].children[1]
                button.addEventListener("click", () => closeDialog(object.children[0] as HTMLElement))
            }

        } catch (error) {
            console.error(error);

        }

    }

    if (newUser === true) {

        await sendPoint()
        await sendCdpData({
            cdp: true
        });
        sendCdpNewUser()
    } else if (newUser === false) {
        sendCdpLogin()
    }


    points.forEach((item) => {
        if (item.children.length > 1) {
            item.children[1].addEventListener("click", () => openDialog(item.children[0] as HTMLElement))
            const button = item.children[0].children[0].children[1]
            button.addEventListener("click", () => closeDialog(item.children[0] as HTMLElement))
        } else {
            item.children[0].addEventListener("click", () => openDialog(item.children[0] as HTMLElement))
        }
    })
    inputsContainer.forEach((item) => {
        const input = item.children[0] as HTMLInputElement
        const search = item.children[1] as HTMLElement
        search.addEventListener("click", () => onSearch(input.value))
    })
    broadcasts.forEach(item => {
        item.children[1].addEventListener("click", () => openDialog(item.children[0] as HTMLElement))
        const button = item.children[0].children[0].children[0]
        button.addEventListener("click", () => closeDialog(item.children[0] as HTMLElement))
    })

    map.parentElement.addEventListener("scroll", () => {
        hand.style.opacity = "0"
    })



    const openDialog = (dialog: HTMLElement) => {
        if (dialog) {
            points.filter(item => (item.classList.contains("fill") || item.classList.contains("me"))).forEach(item => item.children[0].classList.remove("open"))
            dialog.classList.add("open")
        }
        return
    }

    /*     const shareFacebook = () => {
            const uri = facebook.children[1].src;
            window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(uri), 'sharer', 'toolbar=0,status=0,width=626,height=436')
        }
        const shareTwitter = () => {
            const uri = facebook.children[1].src;
            window.open('https://twitter.com/share?ref_src=' + encodeURIComponent(uri))
        } */

    const closeDialog = (dialog: HTMLElement) => {
        if (dialog) {
            dialog.classList.remove("open")
        }
        return
    }

    const onSearch = async (value: string) => {
        try {
            const format: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
            const data = await getMultiTree(value)
            if (data.length <= 0) {
                Swal.fire({ title: "SIN RESULTADOS", text: "No encontramos resultados para su busqueda", icon: "warning", confirmButtonColor: "#000000" })
                return
            }

            data.forEach(item => {
                const object = document.getElementById(`point(${item.x},${item.y})`)
                if (object) {
                    object.innerHTML =
                        `
                    <div class="eternos__tree__modal open">
                            <div class="eternos__modal__header multi">
                                <button class="eternos__modal__close">X</button>
                            </div>
                            <div class="eternos__modal__body multi">
                                ${item.users.map(user => `<p>${new Date(user.date).toLocaleDateString("ES-es", format)} - ${user.name} ${user.lastname}</p>`).join("")}
                            </div>
                    </div>
                    <img class="eternos__tree__image"
                        src="${map.getAttribute("data-treeFree")}"
                        alt="tree(${item.x},${item.y})">
                    `
                    object.children[1].addEventListener("click", () => openDialog(object.children[0] as HTMLElement))
                    const button = object.children[0].children[0].children[0]
                    button.addEventListener("click", () => closeDialog(object.children[0] as HTMLElement))
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

}



const getPoints = async () => {
    try {
        pointsT = await getTrees();
        const format: any = { year: 'numeric', month: 'numeric', day: 'numeric' };

        pointsT.forEach(item => {
            map.innerHTML +=
                `
            <div id="point(${item.x},${item.y})" style="left: ${item.x}px;top: ${item.y}px;" class="eternos__map__tree ${(item.date && item.lastname && item.name) ? "fill" : ""}">
                ${(item.date && item.lastname && item.name) ? (`
                <div class="eternos__tree__modal">
                    <div class="eternos__modal__header">
                        <p>${item.name + " " + item.lastname}</p>
                        <button class="eternos__modal__close">X</button>
                    </div>
                    <div class="eternos__modal__body">
                        <img src="${map.getAttribute("data-treeFree")}"
                            alt="eternos__modal__image">
                        <p>Siembra digital: ${new Date(item.date).toLocaleDateString("ES-es", format)}</p>
                    </div>
                </div>
                `)
                    :
                    ""
                }
                <img class="eternos__tree__image"
                    src="${map.getAttribute("data-treeFree")}"
                    alt="tree(${item.x},${item.y})">
            </div>
            `
        })

    } catch (error) {
        console.error(error);

    }

}


const sendCdpNewUser = () => {
    const cuid = CryptoJS.SHA256(window.drupalSettings.user.uid).toString(CryptoJS.enc.Hex)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'GAEvent',
        event_category: 'Register',
        event_action: 'Sucess',
        userUid: cuid,
        campaign_description: 'Eternos'
    })
}

const sendCdpLogin = () => {
    const cuid = CryptoJS.SHA256(window.drupalSettings.user.uid).toString(CryptoJS.enc.Hex)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'GAEvent',
        event_category: 'Login',
        event_action: 'Sucess',
        userUid: cuid,
        campaign_description: 'Eternos'
    })
}